export function homePath() {
  return "/";
}

export function categoryPath(categorySlug: string, brandSlug?: string) {
  return brandSlug
    ? `/category/${categorySlug}/${brandSlug}`
    : `/category/${categorySlug}`;
}

export function searchPath(query?: string) {
  return query ? `/search?q=${encodeURIComponent(query)}` : "/search";
}

export function productPath(productSlug: string) {
  return `/product/${productSlug}`;
}
